export default function currency (val) {
  const currencyValue = val.toLocaleString('en-US', {maximumFractionDigits:2, minimumFractionDigits:2})
  return currencyValue
}